import React from 'react';
import Footer from '../Footer';

function Fitness() {
    return (
        <div>
            <h1>Fitness</h1>
            <h4>All services are listed here</h4>
            <Footer/>
        </div>
    );
}

export default Fitness;
